import { html } from "lit";
import { styleMap } from "lit/directives/style-map.js";

export const IconSmallSearch = html`<svg
  class="icon icon-30 input-icon"
  width="22"
  height="22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 22 22"
>
  <path
    d="m14.575 14.575 3.575 3.575M3.85 9.979a6.129 6.129 0 1 0 12.257 0 6.129 6.129 0 0 0-12.257 0Z"
    stroke="#F1554C"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;

export const IconFilter = html`<svg
  class="icon icon-sm me-1"
  width="20"
  height="20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g
    clip-path="url(#a)"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    viewBox="0 0 20 20"
  >
    <path
      d="M4.667 16v-4.667M4.667 8.667V4M10 16v-6M10 7.333V4M15.333 16v-3.333M15.333 10V4M2.667 11.333h4M8 7.333h4M13.333 12.667h4"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M2 2h16v16H2z" /></clipPath>
  </defs>
</svg>`;

export const IconWarning = html`
  <svg
    class="icon icon-xs icon-tooltip"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2098_39520)">
      <path
        opacity="0.5"
        d="M8 8.09961L8 11.6996"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.5"
        d="M8 5.30039L8 4.90039"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.5"
        d="M7.99995 15.3002C11.7555 15.3002 14.8 12.2557 14.8 8.50019C14.8 4.74466 11.7555 1.70019 7.99995 1.70019C4.24441 1.7002 1.19995 4.74466 1.19995 8.5002C1.19995 12.2557 4.24441 15.3002 7.99995 15.3002Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2098_39520">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(16 16.5) rotate(180)"
        />
      </clipPath>
    </defs>
  </svg>
`;

export const chevron = (flip: boolean = false) => html`<svg
  class="icon icon-xs text-dark"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 17 16"
  style=${styleMap({
    transform: flip ? "scale(1,-1)" : "",
    transition: "transform 0.2s",
  })}
>
  <path
    d="m2.5 5 6 6 6-6"
    style="fill:none;stroke:#7887a4;stroke-linecap:round;stroke-linejoin:round"
  />
</svg>`;

export const AddShortlist = html`<svg
  class="icon"
  width="15"
  height="16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 15 16"
>
  <circle cx="7.5" cy="8" r="6.375" stroke="#F1554C" stroke-width="1.5" />
  <path
    d="M4.875 7.813h2.813m2.812 0H7.687m0 0v2.812m0-2.813V5"
    stroke="#F1554C"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>`;
export const RemoveShortlist = html`<svg
class="icon"
width="15"
height="16"
fill="none"
xmlns="http://www.w3.org/2000/svg"
viewBox="0 0 15 16"
>
<circle cx="7.5" cy="8" r="6.375" stroke-width="1.5" />
<path
  d="M4.875 7.813h2.813m2.812 0H7.687m0 0v2.812m0-2.813V5"
  stroke-width="1.5"
  stroke-linecap="round"
  stroke-linejoin="round"
  transform="rotate(-45 8 8)"
/>
</svg>`;
